module.exports = __webpack_public_path__ + "static/media/basketball.519000c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/basketball.jpg
// module id = 21
// module chunks = 0